







import Vue from "vue";
export default Vue.extend({
  mounted() {
    setTimeout(() => {
      this.$router.push({ path: "/logout" });
    }, 1000);
  }
});
